import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import ChildRecordTable from '../Record/RecordTable';
import {Collapse} from 'antd';
import { fetchCurrency } from "../Components/Utility";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";

const SearchResults = () => {
  const location = useLocation();
  const { searchResults,keyword } = location.state || {};
  const [groupedData, setGroupedData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [activeCurrencies,setActiveCurrencies] = useState([]);
  // const userCurrency = Cookies.get('userCurrency');

  useEffect(() => {
    if (searchResults) {
      const grouped = {};
      const columnConfig = {};

      // Iterate over all objects (like Opportunity, User, etc.)
      Object.keys(searchResults).forEach((objectKey) => {
        const objectData = searchResults[objectKey];
      
        // Check if the object has both 'records' and 'mt_fields' properties
        if (objectData && objectData.records && objectData.mt_fields) {
          const { records, mt_fields } = objectData;
      
        // Get field metadata from mt_fields for easy lookup
        const fieldMetadata = mt_fields.reduce((acc, field) => {
          acc[field.name] = field; // Map field names to their metadata
          return acc;
        }, {});
      
        // Filter out empty or invalid records
        const validRecords = Array.isArray(records)
          ? records.filter((record) => record && typeof record === "object")
          : [];
      
        // Only add non-empty groups
        if (validRecords.length > 0) {
          grouped[objectKey] = validRecords;

          // Dynamically set columns based on the first record's keys
          columnConfig[objectKey] = Object.keys(validRecords[0]).map((field) => {
            const fieldMeta = fieldMetadata[field];

            return {
              title: fieldMeta?.label || field,
              dataIndex: field,
              key: field,
              type: fieldMeta?.type,
              render: (text, record) => {
                // Your custom rendering logic here...
                return text || "";
              },
            };
          });
        }
      }
      });

      setGroupedData(grouped);
      setColumns(columnConfig); 
    }
  }, [searchResults]);

  const fetchCurrency = async () => {
    try {
        // setLoading(true);
        const apiService = new ApiService(`${BASE_URL}/mt_currencies`, {
            'Content-Type': 'application/json',
        }, 'GET');
        const response = await apiService.makeCall();
        console.log('responseresponse:',response);
        setActiveCurrencies(response);
    } catch (err) {
        console.error("Error fetching metadata:", err);
    }finally{
        // setLoading(false);
    }
}
const getConvertedValue = (amount, fromCode, toCode) => {
    const parsedAmount = parseFloat(amount);
  
    // Check for invalid or empty amount
    if (isNaN(parsedAmount) || fromCode === toCode) {
      return isNaN(parsedAmount) ? '0.00' : parsedAmount.toFixed(2);
    }
    const fromCurrency = activeCurrencies.find(c => c.iso_code === fromCode);
    const toCurrency = activeCurrencies.find(c => c.iso_code === toCode);
    console.log('activeCurrencies isss',activeCurrencies);
    console.log('fromCurrency',fromCurrency,toCurrency);
    if (!fromCurrency || !toCurrency || !fromCurrency.conversion_rate || !toCurrency.conversion_rate) {
      return '0.00';
    }
  
    const inCorporate = parsedAmount / fromCurrency.conversion_rate;
    const converted = inCorporate * toCurrency.conversion_rate;
  
    return converted.toFixed(2);
  };
  return (
    <div>
      <h1>Search Results</h1>      
      {Object.values(searchResults).map((object) => (
  <Collapse
    style={{ marginBottom: "10px" }}
    key={object.object_name}
    defaultActiveKey={["1"]}
  >
    <Collapse.Panel header={object.object_name} key="1">
      {/* Send data to ChildRecordTable */}
      <ChildRecordTable
        fetchCurrency={fetchCurrency}
        getConvertedValue={getConvertedValue}
        fieldsData={object.mt_fields}
        childRecords={object.records}
        childObjectName={object.object_name}
        isGlobalSearch={true}
        keyword={keyword}
        // total={}
        // keyword={}
      />
      {/* <ListViewTable
        fieldsData={object.mt_fields}
        childRecords={object.records}
      /> */}
    </Collapse.Panel>
  </Collapse>
))}
    </div>
  );
};

export default SearchResults;
